/**
 * An error message returned by a REST call
 */
export default kendo.data.Model.define({

    fields: {

        /**
         * Server cause(this is not the message to display to user)
         */
        cause: {
            type: "string",
            nullable: true,
            editable: false
        },

        /**
         * Server stacktrace
         */
        stackTrace: {
            type: "string",
            nullable: true,
            editable: false
        },

        /**
         * The error thrown(eg com.docfinity.entity.EntityNotFountException
         */
        type: {
            type: "string",
            editable: false
        },

        /**
         * Message to display to user
         */
        message: {
            type: "string",
            editable: false,
            nullable: true
        },

        /**
         * Error code
         */
        localeErrorCode: {
            type: "string",
            editable: false,
            nullable: true

        },

        /**
         * The localized message to give user
         */
        localizedMessage: {
            type: "string",
            editable: false,
            nullable: true
        },

        /**
         * The HTTP response code
         */
        statusCode: {
            type: "number",
            editable: false,
            nullable: false
        }

    }

});